import { render, staticRenderFns } from "./FinishedTicketsRank.vue?vue&type=template&id=f448fa12&scoped=true&"
import script from "./FinishedTicketsRank.vue?vue&type=script&lang=js&"
export * from "./FinishedTicketsRank.vue?vue&type=script&lang=js&"
import style0 from "./FinishedTicketsRank.vue?vue&type=style&index=0&id=f448fa12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f448fa12",
  null
  
)

export default component.exports